module.exports = __webpack_public_path__ + "img/fr.36b4adb2.svg";